import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { PortfolioAssetDetailsResponse } from '../../models';
import { getUnsupportedPortfolioAssetDetailsResponses, PortfolioHoldingsResolutionState, selectAllPortfolioAssetDetailsResponses } from '../../store/portfolio-holdings-resolution';
import * as actions from '../../store/portfolio-holdings-resolution';


@Injectable({
	providedIn: 'root'
})
export class PortfolioHoldingsResolutionStoreService {
	private allPortfolioAssetDetailsResponses$: Observable<PortfolioAssetDetailsResponse[]>;
	private unsupportedPortfolioAssetDetailsResponses$: Observable<PortfolioAssetDetailsResponse[]>;

	constructor(private store: Store<PortfolioHoldingsResolutionState>) {
		this.init();
	}

	public init(): void {
		this.allPortfolioAssetDetailsResponses$ = this.store.pipe(select(selectAllPortfolioAssetDetailsResponses));
		this.unsupportedPortfolioAssetDetailsResponses$ = this.store.pipe(select(getUnsupportedPortfolioAssetDetailsResponses));
	}

	public setAllPortfolioAssetDetailsResponses(portfolioAssetDetailsResponses: PortfolioAssetDetailsResponse[]): void {
		this.store.dispatch(actions.setAllPortfolioAssetDetailsResponses({ portfolioAssetDetailsResponses }));
	}

	public getPortfolioAllAssetDetailsResponses(): Observable<PortfolioAssetDetailsResponse[]> {
		return this.allPortfolioAssetDetailsResponses$;
	}

	public getUnsupportedPortfolioAssetDetailsResponses(): Observable<PortfolioAssetDetailsResponse[]> {
		return this.unsupportedPortfolioAssetDetailsResponses$;
	}
}
